import { privateInstance } from "../configs";

export const supplierApi = {
  async getSuppliers() {
    const res = await privateInstance.get("/invoices/api/suppliers/cl/");
    return res.data;
  },
  async retrieveSupplier(id) {
    const res = await privateInstance.get(`/invoices/api/suppliers/rud/${id}/`);
    return res.data;
  },
  async postSupplier(supplier) {
    const res = await privateInstance.post(
      `/invoices/api/suppliers/cl/`,
      supplier
    );
    return res.data;
  },
  async putSupplier(id, supplier) {
    const res = await privateInstance.put(
      `/invoices/api/suppliers/rud/${id}/`,
      supplier
    );
    return res.data;
  }
};
